import { render, staticRenderFns } from "./IAAR.vue?vue&type=template&id=6bc77dbc&scoped=true&"
import script from "./IAAR.vue?vue&type=script&lang=ts&"
export * from "./IAAR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc77dbc",
  null
  
)

export default component.exports